import { render, staticRenderFns } from "./AllCountryCard.vue?vue&type=template&id=4c67993e&scoped=true&"
import script from "./AllCountryCard.vue?vue&type=script&lang=js&"
export * from "./AllCountryCard.vue?vue&type=script&lang=js&"
import style0 from "./AllCountryCard.vue?vue&type=style&index=0&id=4c67993e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67993e",
  null
  
)

export default component.exports